import React from "react";
import "./CustomInput.scss"
import user from "../../assets/profile-2.svg"
import mail from "../../assets/mail.svg"
import address from "../../assets/location-black.svg"


const CustomTextArea = ({ label, icon, value, onChange, placeholder, required, error, errorText, disable }) => {
    const getIcons = () => {
        const icons = {
            user: user,
            email: mail,
            address: address,
        };

        return icons[icon] || user;
    };

    return (
        <div className="CustomInput">
            <div className="input-label">
                {required && <span className="input-req">* </span>}
                {label}
            </div>
            <div className={`CustomInput-container ${error ? "error" : disable ? "disable" : ""}`}>
                {icon && <img className="CustomInput-container-icon" alt="" src={getIcons()} />}
                <textarea
                    className="CustomInput-container-textareanew"
                    value={value}
                    onChange={onChange}
                    type="text"
                    placeholder={placeholder}
                    disabled={disable ?? false}
                />
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div >
    )
}
export default CustomTextArea